export const newsroomPageData = {
  seoText: 'Newsroom | Joy',
  content:
    'Please reach out to <a style="color: #4C458A;text-decoration: underline;" href="mailto:press@withjoy.com">press@withjoy.com</a> with questions or media inquiries.',

  announcements: [
    {
      title: 'Joy Raises $60M in Series B to Extend their Modern Wedding Planning Platform for All Life Events',
      subtitle: `The funding round was led by General Catalyst, with Nordstrom, HP Board Member Stacy Brown-Philpot joining Joy’s Board of Directors. The brand has grown rapidly year-over-year with 3x as many U.S. couples planning their weddings on Joy and using its all-in-one registry. Wedding gifts going through the registry has also 4x, as the platform offers a seamless solution to receive gifts, experiences, zero-fee cash funds and charities.`,
      link:
        'https://www.prnewswire.com/news-releases/joy-raises-60m-in-series-b-to-extend-their-modern-wedding-planning-platform-for-all-life-events-301689652.html',
      date: 'November 30th, 2022',
    },
    {
      title: 'Joy announces $20M in new funding to continue to build a smarter way to plan weddings',
      subtitle: `Joy's explosive organic growth and modern take on wedding planning enabled the company to raise $20 million in new funding. The round was led by Valor Siren Ventures, and joined by Ashton Kutcher and Guy Oseary's Sound Ventures, Zola Global, Avalon Ventures, and Sierra Ventures.`,
      link:
        'https://www.prnewswire.com/news-releases/joy-announces-20m-in-new-funding-to-continue-to-build-a-smarter-way-to-plan-weddings-301367274.html',
      date: 'September 1st, 2021',
    },
    {
      title: 'How to Plan Your Destination Wedding with Joy',
      subtitle:
        'An important part of any destination wedding checklist is creating your wedding website. Your Joy wedding website helps you share travel tips, event details and more with guests, collect RSVPs, and even help guests book travel.',
      link: 'https://withjoy.com/blog/how-to-plan-your-destination-wedding-with-joy/',
      date: 'June 27th, 2021',
    },
    {
      title: 'How to Plan Your Wedding Shower with Joy',
      subtitle:
        'Ensure your wedding shower goes off without a hitch. Joy provides all the tools you need to easily plan this special party, send invitations, and make sure guests have the information they need.',
      link: 'https://withjoy.com/blog/how-to-plan-your-wedding-shower-with-joy/',
      date: 'May 7th, 2021',
    },
    {
      title: 'Plan your Virtual Wedding with Joy',
      subtitle:
        'From sending invites, to hosting your virtual event, to sharing memories after your big day, Joy supports every step of your virtual wedding.',
      link: 'https://withjoy.com/blog/virtual-weddings/',
      date: 'September 8th, 2020',
    },
    {
      title: 'Joy Develops COVID Wedding Calculator to Guide Couples Plans Amid the Coronavirus',
      subtitle:
        'The COVID Wedding Calculator asks couples to enter their wedding details, indicates the level of changes that may be necessary to their plans, and provides an overview of changes to consider making.',
      link:
        'https://www.prnewswire.com/news-releases/joy-develops-covid-wedding-calculator-to-guide-couples-plans-amid-the-coronavirus-301085541.html',
      date: 'June 30th, 2020',
    },
    {
      title: 'Share Your Changing Wedding Plans with Change the Dates',
      subtitle:
        'We know many of your wedding plans are changing due to the coronavirus, and during this stressful time we want to make it as easy as possible for you to share wedding updates with your guests. Joy’s new Change the Dates help you do just that, with free e-cards available in hundreds of beautiful designs and featuring fully customizable text. ',
      link: 'https://withjoy.com/blog/change-the-dates/',
      date: 'May 7th, 2020',
    },
    {
      title: 'COVID-19 Wedding Planning Resource Center',
      subtitle:
        'Having to change your wedding plans due to the coronavirus, or any event of this nature out of your control, can be personally devastating. We know many of you have already had to make difficult decisions. We’re here to serve as a resource and helping hand through this trying time. Read on for expert advice, ways to connect with other couples in your shoes, and tips for using your Joy website to update your guests on your wedding plans and, if need be, help them virtually join your ceremony.',
      link: 'https://withjoy.com/blog/covid-resource-center/',
      date: 'March 13th, 2020',
    },
    {
      title: 'Plan Your Rehearsal Dinner with Joy',
      subtitle:
        'Helping you plan your rehearsal dinner is one of the many ways Joy simplifies wedding planning. From creating your wedding schedule and organizing your guest list, to sending invitations and asking RSVP questions, Joy helps you plan your big day each step of the way.',
      link: 'https://withjoy.com/blog/plan-your-rehearsal-dinner-with-joy/',
      date: 'December 11th, 2019',
    },
    {
      title: 'Invitations to Match Your Joy Wedding Website — Now Available to Ship Internationally via Paperlust',
      subtitle:
        'We’ve teamed up with Paperlust, an Australia-based invitation company, to offer unique invitation designs to match your wedding website, which can be shipped internationally. Paperlust is dedicated to supporting independent artists, developing delightful, custom stationery, and promoting sustainability.',
      link: 'https://withjoy.com/blog/invitations-via-paperlust/',
      date: 'December 10th, 2019',
    },
    {
      title: 'A Better Way to RSVP with Joy',
      subtitle:
        'Joy’s powerful online RSVP system is intuitive for your guests and incredibly helpful to you and your fiancé. Organize your guest list, include follow-up questions, record plus-ones, ask multiple choice questions, and more.',
      link: 'https://withjoy.com/blog/a-more-sophisticated-online-rsvp-2/',
      date: 'November 13th, 2019',
    },
    {
      title: 'Streamline Guest Communication with Joy’s Wedding App',
      subtitle:
        'These wedding app features help streamline communication with your guests and ensure everything goes smoothly on your wedding day. Read on for our tips for using your wedding app for guest communication.',
      link: 'https://withjoy.com/blog/wedding-app-for-guest-communication/',
      date: 'May 27th, 2018',
    },
    {
      title: 'Joy, Free Wedding Planning Website and App, Releases New Guest Management Suite',
      subtitle:
        'Joy, the free wedding website and app that brings all of your wedding into one place, announced the launch of a new guest management suite. In addition to the wedding website and app, Joy now offers beautifully-designed online wedding invitations and save the dates, the ability to control +1s, and a fully-customizable RSVP manager — making inviting and communicating with guests a breeze.',
      link:
        'https://www.prnewswire.com/news-releases/joy-free-wedding-planning-website-and-app-releases-new-guest-management-suite-300517424.html',
      date: 'September 12, 2017',
    },
  ],

  features: [
    {
      pressImg: 'newsroom/people-logo.png',
      title: 'Brides, Take Note: These 16 Wedding Registries Should Be on Your Radar',
      subtitle: `“With Joy, you don't have to come up with specific products to put on your registry; you just have to have an idea of where you plan to shop or how you plan to spend your money. While you can also add physical items from Joy's catalog or sync to another registry, Joy stands out most for its many gift card options and cash fund categories, none of which involve any transaction fees.”`,
      link: 'https://people.com/lifestyle/best-wedding-registries/',
    },
    {
      pressImg: 'newsroom/brides-logo-v2.png',
      title: 'The Best Wedding Websites for Your Big Day',
      subtitle:
        '“Best Overall: Joy. Why We Chose It: Joy stands out for hitting the mark on detailed wedding websites powered by organizational and planning tools, all for free.”',
      link: 'https://www.brides.com/best-wedding-websites-5272206',
    },
    {
      pressImg: 'newsroom/cosmo-logo-2.png',
      title: 'These are the 18 Best Places to Register for a Wedding',
      subtitle:
        '“This all-in-one service offers design templates for your wedding website, save the dates, and invitations, in addition to a section that allows you to build a registry with any gifts from any store. Despite having SO many features, Joy is super straightforward and easy to navigate.”',
      link: 'https://www.cosmopolitan.com/lifestyle/g40070353/best-wedding-registries-list/',
    },
    {
      pressImg: 'newsroom/gma-logo.png',
      title: 'Building a Wedding on a Budget',
      subtitle:
        '“CEO and co-founder of the wedding website and app Joy, Vishal Joshi, talks about how to save big while planning your big day.”',
      link: 'https://www.goodmorningamerica.com/news/video/building-wedding-budget-82311369',
    },
    {
      pressImg: 'newsroom/fortune-logo.png',
      title: 'Joe Montana on Why He Invested in Events Startup Joy: "The Problem Was Personal to Them"',
      subtitle:
        // eslint-disable-next-line quotes
        "&ldquo;'We at Liquid2 Ventures invested in Joy’s Seed round out of Y Combinator when they had just a few hundred weddings, and I have watched them grow to hundreds of thousands of weddings. Joy has achieved massive organic growth due to the strength of their product.' - Joe Montana.&rdquo;",
      link: 'https://fortune.com/2021/10/03/joe-montana-liquid2-ventures-investment-joy-wedding-events-planning/',
    },
    {
      pressImg: 'newsroom/forbes.png',
      title: 'Joy Raises $20 Million For Its Free All-In-One Wedding Planning Platform',
      subtitle:
        '“Joy stands out in the increasingly crowded wedding sector. To keep building out its technology, the San Francisco-based startup raised $20 million led by Valor Siren Ventures.”',
      link:
        'https://www.forbes.com/sites/rebeccaszkutak/2021/09/01/joy-raises-20-million-for-its-free-all-in-one-wedding-planning-platform',
    },
    {
      pressImg: 'newsroom/New_York_Times_logo.svg',
      title: 'How to Live Stream Your Wedding',
      subtitle:
        '“Live streaming a wedding is becoming mainstream,’ said Vishal Joshi, the founder and chief executive of Joy, a wedding planning and technology company based in San Francisco that recently started a free live-streaming feature on its website.”',
      link: 'https://www.nytimes.com/2020/04/25/fashion/weddings/how-to-live-stream-your-wedding.html',
    },
    {
      pressImg: 'newsroom/in-style-logo.svg',
      title: 'Best Website Builder: Joy',
      subtitle:
        '“With its massive list of features and intuitive design, Joy is a one-stop shop for organizing every single wedding detail, for all to see before, on, and long after the ceremony is over.”',
      link: 'https://www.instyle.com/weddings/best-wedding-website-builder-joy',
    },
    {
      pressImg: 'newsroom/New_York_Times_logo.svg',
      title: 'A Dream Wedding On a Budget',
      subtitle:
        '“At least one cutting-edge wedding service costs nothing: Joy, a digital platform, can save couples by bundling digital needs in a single online location.”',
      link: 'https://www.nytimes.com/2018/06/08/fashion/weddings/dream-wedding-on-a-budget.html',
    },
    {
      pressImg: 'newsroom/vogue-logo.svg',
      title: 'Wedding 2.0: A Beginner’s Guide to Creating the Perfect Wedding Website',
      subtitle: '“And for the most options with the best price tag (it’s free!), consider Joy.”',
      link: 'https://www.vogue.com/article/how-to-build-a-wedding-website-for-beginners',
    },
    {
      pressImg: 'newsroom/Refinery29_logo.svg',
      title: 'The Best Apps for Wedding Planning',
      subtitle:
        '“Joy’s desktop websites and wedding planning app work in conjunction with each other. You can create your guest website online, and keep planning through the app. Your guests can access the app, in addition to the website, too.”',
      link: 'https://www.refinery29.com/en-us/best-apps-for-brides#slide-20',
    },
    {
      pressImg: 'newsroom/Mashable_Logo.svg',
      title: 'How to Choose a Wedding Website Provider Without Losing Your Mind',
      subtitle: '“The thing that most distinguishes Joy is its clarity and user-friendly interface.”',
      link: 'https://mashable.com/article/wedding-website-provider-comparisons/',
    },
    {
      pressImg: 'newsroom/Telegraph_UK_Logo.png',
      title: 'Can’t afford a wedding planner? Check out the 7 best apps for making your wedding stress free.',
      subtitle:
        '“Best of all, [Joy] will allow you and your friends and family to upload photos to a Moments timeline where, just like with Instagram and Facebook, they can comment on and like each one.”',
      link: 'https://www.telegraph.co.uk/weddings/advice/cant-afford-wedding-planner-check-7-best-apps-making-wedding/',
    },
    {
      pressImg: 'newsroom/techcrunch-vector-logo.svg',
      title: 'Joy Aims to be a Smarter Wedding Planner for the Modern Bride',
      subtitle:
        '“Joy does all that, but also incorporates an assistant to help you navigate, provides customizable designs, an app for updating info and tools for handling the real life event such as the ability for guests to upload their photos as they take them and share on a big screen during the reception.”',
      link: 'https://techcrunch.com/2016/08/16/withthisbotitheewed/',
    },
    {
      pressImg: 'newsroom/hello-logo-solo.svg',
      title: '10 Wedding Planning Apps Every Bride-To-Be Needs',
      subtitle: '“When it comes to wedding planning, there’s pretty much nothing you can’t do with Joy.”',
      link: 'https://www.hellomagazine.com/brides/2019011066459/wedding-planning-apps-for-brides/',
    },
    {
      pressImg: 'newsroom/Business_Insider_Logo.svg',
      title: 'We compared the top 5 wedding registries in the US including Amazon, Zola, and Target — here are all the pros and cons',
      subtitle: '“Joy, a free wedding planning website and app that brings the many parts of wedding planning into one simple interface”',
      link: 'https://www.businessinsider.com/best-wedding-registry',
    },
    {
      pressImg: 'newsroom/techcrunch-vector-logo.svg',
      title: 'Digital wedding planner Joy says “I Do” to $4.5 million in seed funding',
      subtitle:
        '“There is no one-stop shop for your invite, CRM, planning and guest management needs… Joy aspires to be that one-stop shop, giving brides and grooms peace of mind, and better yet, joy.”',
      link: 'https://techcrunch.com/2016/11/08/digital-wedding-planner-joy-says-i-do-to-4-5-million-in-seed-funding/',
    },
  ],

  carousel: [
    {
      pressImg: 'newsroom/forbes.png',
      title: 'Joy Raises $20 Million For Its Free All-In-One Wedding Planning Platform',
      subtitle:
        'Joy stands out in the increasingly crowded wedding sector. To keep building out its technology, the San Francisco-based startup raised $20 million led by Valor Siren Ventures.',
      link:
        'https://www.forbes.com/sites/rebeccaszkutak/2021/09/01/joy-raises-20-million-for-its-free-all-in-one-wedding-planning-platform',
      img: 'newsroom/joy_features_forbes.jpg',
    },
    {
      pressImg: 'newsroom/New_York_Times_logo.svg',
      title: 'How to Live Stream Your Wedding',
      subtitle:
        'Live streaming a wedding is becoming mainstream,’ said Vishal Joshi, the founder and chief executive of Joy, a wedding planning and technology company based in San Francisco that recently started a free live-streaming feature on its website.',
      link: 'https://www.nytimes.com/2020/04/25/fashion/weddings/how-to-live-stream-your-wedding.html',
      img: 'newsroom/Nytimes_Live_Streaming_Weddings.jpg',
    },
    {
      pressImg: 'newsroom/in-style-logo.svg',
      title: 'Best Website Builder: Joy',
      subtitle:
        'With its massive list of features and intuitive design, Joy is a one-stop shop for organizing every single wedding detail, for all to see before, on, and long after the ceremony is over.',
      link: 'https://www.instyle.com/weddings/best-wedding-website-builder-joy',
      img: 'newsroom/NYtimes.png',
    },
    {
      pressImg: 'newsroom/New_York_Times_logo.svg',
      title: 'A Dream Wedding On a Budget',
      subtitle:
        'At least one cutting-edge wedding service costs nothing: Joy, a digital platform, can save couples by bundling digital needs in a single online location.',
      link: 'https://www.nytimes.com/2018/06/08/fashion/weddings/dream-wedding-on-a-budget.html',
      img: 'newsroom/vogue.png',
    },
    {
      pressImg: 'newsroom/vogue-logo.svg',
      title: 'Wedding 2.0: A Beginner’s Guide to Creating the Perfect Wedding Website',
      subtitle: 'And for the most options with the best price tag (it’s free!), consider Joy.',
      link: 'https://www.vogue.com/article/how-to-build-a-wedding-website-for-beginners',
      img: 'newsroom/instyle.png',
    },
  ],
  brandAssets: {
    logosTitle: 'Logos',
    photosTitle: 'Photos & Videos',
    pressKitTitle: 'Press Kit',
    downloadButtonText: 'Download',
  },
} as const;
